import { Icon } from "@circle-react-shared/Icon";
import { Toolbar } from "../../Toolbar";

interface LoadingIndicatorProps {
  label: string;
}

export const LoadingIndicator = ({ label }: LoadingIndicatorProps) => (
  <Toolbar.Indicator
    label={label}
    hideBackground
    className="border border-[#2B2E33]"
  >
    <Icon type="live-spinner" className="h-4 w-4 animate-spin" />
  </Toolbar.Indicator>
);
